export default function PHP_ftp_fput() {
  return (
    <div>
      <h1>PHP_ftp_fput</h1>
    </div>
  );
}
